import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { func } from "prop-types";
import { translate } from "react-i18next";
import compose from "ramda/src/compose";
import contains from "ramda/src/contains";

import {
  Button,
  FloatLabelInput,
  FloatLabelTextArea,
  Form,
} from "shared/components";
import Loader from "../../../../components/Loading";
import { createCommonIncident } from "../../../../services/state/actions";
import * as Mask from "./../../../../services/utils/mask";
import { SIEBEL } from "services/state/billing/constants";
import styles from "../../styles.css";

const required = (value) => (value ? undefined : "Campo obrigatório");
class CommonIncidentForm extends Component {
  isSiebel() {
    const { product } = this.props;
    return product && contains(product.productSystem, [SIEBEL]);
  }

  onSubmit = (form) => {
    const { t, createCommonIncident, onNextStep, onReset } = this.props;

    const checklist = {
      data: { ...form /* , reason */ },
      labels: {
        reason: t("MSG_0397"),
        contactName: t("MSG_0212"),
        contactPhone: t("MSG_0206"),
        description: t("MSG_0202"),
        timeSlot: t("MSG_0205"),
      },
    };

    return createCommonIncident(checklist, onNextStep, onReset);
  };

  renderNameInput = (field) => {
    const {
      meta: { touched, error, invalid },
    } = field;
    return (
      <FloatLabelInput
        id="contactName"
        name="contactName"
        onChange={field.input.onChange}
        label={field.label}
        value={field.input.value ? field.input.value : ""}
        invalid={touched && invalid}
        error={error}
      />
    );
  };

  renderPhoneInput = (field) => {
    const {
      meta: { touched, error, invalid },
    } = field;
    return (
      <FloatLabelInput
        id="contactPhone"
        name="contactPhone"
        onChange={field.input.onChange}
        label={field.label}
        maxLength="15"
        value={field.input.value ? field.input.value : ""}
        invalid={touched && invalid}
        error={error}
      />
    );
  };

  renderDescriptionInput = (field) => {
    const {
      meta: { touched, error, invalid },
    } = field;
    return (
      <FloatLabelTextArea
        id="description"
        name="description"
        label={field.label}
        preset="modalTextArea"
        onChange={field.input.onChange}
        value={field.input.value ? field.input.value : ""}
        invalid={touched && invalid}
        error={error}
        noResize
      />
    );
  };

  renderTimeSlotInput = (field) => {
    const {
      meta: { touched, error, invalid },
    } = field;
    return (
      <FloatLabelInput
        id="timeSlot"
        name="timeSlot"
        onChange={field.input.onChange}
        label={field.label}
        maxLength={field.maxLength}
        value={field.input.value ? field.input.value : ""}
        invalid={touched && invalid}
        error={error}
      />
    );
  };

  render() {
    const { t, handleSubmit, submitting, onPreviousStep } = this.props;
    return (
      <Fragment>
        <Form onSubmit={handleSubmit(this.onSubmit)}>
          <p className={styles.formInstructions}>{t("MSG_0211")}</p>
          <Field
            name="contactName"
            validate={required}
            component={this.renderNameInput}
            label={t("MSG_0212")}
          />
          <Field
            validate={required}
            name="contactPhone"
            component={this.renderPhoneInput}
            label={t("MSG_0206")}
            format={Mask.phone}
            normalize={Mask.algarPhone}
          />
          <Field
            validate={required}
            name="description"
            component={this.renderDescriptionInput}
            label={t("MSG_0202")}
          />
          <Field
            validate={required}
            name="timeSlot"
            component={this.renderTimeSlotInput}
            label={t("MSG_0205")}
            format={Mask.timeRange}
            normalize={Mask.timeRange}
          />
          <div className={styles.incidentModalButtons}>
            <Button onClick={onPreviousStep} relevance="low">
              {t("MSG_0292")}
            </Button>

            <Button relevance="normal" type="submit" callToAction>
              {this.isSiebel() ? t("MSG_0210") : t("MSG_0007")}
            </Button>
          </div>
        </Form>

        <Loader isOpen={submitting} />
      </Fragment>
    );
  }
}

CommonIncidentForm.propTypes = {
  onPreviousStep: func.isRequired,
  onNextStep: func.isRequired,
};

function validate(values) {
  const error = {};
  return error;
}

const reduxFormConfig = {
  form: "CommonIncidentForm",
  validate,
};

const enhance = compose(
  translate(),
  reduxForm(reduxFormConfig),
  connect(null, { createCommonIncident })
);

export default enhance(CommonIncidentForm);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/ModalCommonIncident/CommonIncidentForm.js